import { render, staticRenderFns } from "./AddUserDialog.vue?vue&type=template&id=5fc2a70b&"
import script from "./AddUserDialog.vue?vue&type=script&lang=js&"
export * from "./AddUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddUserDialog.vue"
export default component.exports